export default __webpack_public_path__ + "static/media/tick.e03f93ee.svg";